import React from 'react';
import {get, orderBy} from 'lodash';
import {gql} from 'apollo-boost';
//import {v4 as uuidv4} from 'uuid';

import client from '../../../../../src/graphql/client';

import respImgQuery from '../../../../../src/graphql/queries/resp-img';
import refactorRespImg from '../../../../../src/data-restructure/ui/resp-img';
import seoQuery from '../../../../../src/graphql/queries/seo';
import refactorFinanceRates from '../../../../../src/data-restructure/data/repayment-calc-rates';
import financeRatesQuery from '../../../../../src/graphql/queries/finance-rates';
import ModelStepTwoFloorplanConfigurationPage from '../../../../../src/containers/ModelStepTwoFloorplanConfigurationPage';


const BuildPriceStepTwoFloorplanConfigurationPage = (props) => {
  return (
    <ModelStepTwoFloorplanConfigurationPage
      {...props}
    />
  )
}


export async function getStaticPaths() {

  const GET_DYNAMIC_PATHS_QUERY = gql`
    query GET_DYNAMIC_PATHS {
        modelsFloorPlans(where: {status: PUBLISH}, first: 10000) {
          nodes {
            uri
            acf_floor_plan {
                modelSeries {
                  ... on Series {
                    uri
                  }
                }
            }
            acf_domains {
              assignedDomains
            }
          }
        }
    }
  `

  const result = await client.query({
    query: GET_DYNAMIC_PATHS_QUERY
  });

  const floorplans = get(result, 'data.modelsFloorPlans.nodes', []);
  let paths = [];
  
  const filteredFloorplans = floorplans.filter((item) => {
    // filter out if doesn't have uri
    return item.uri && item.acf_floor_plan.modelSeries[0]?.uri;
  });
  
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const domain = countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz';

  filteredFloorplans.forEach(fp => {
    const assignedDomains = get(fp, 'acf_domains.assignedDomains', []);
    assignedDomains.indexOf(domain) !== -1 && fp.acf_floor_plan.modelSeries[0].uri != 'new-models' && paths.push({
      params: {
        series: fp.acf_floor_plan.modelSeries[0].uri,
        floorplan: fp.uri
      }
    });
  })

  return { paths , fallback: false }
}


export async function getStaticProps(context) {
    const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
    const {
      params
    } = context
    
    const GET_DYNAMIC_PROPS = gql`
      query GET_DATA($seriesuri: String, $floorplanuri: String) {
          seriesBy(uri: $seriesuri) {
              id
              title
              link
              acf_domains {
                assignedDomains
              }
              acf_series_v2 {
                sv2SubnavLogo {
                  ${respImgQuery}
                }
                sv2SubnavColour
              }
              acf_series {
                seriesDisclaimer {
                  ... on Disclaimer {
                    acf_disclaimer {
                      disclaimerText
                    }
                  }
                }
                seriesSpecsRep {
                  seriesSpecRepTitle
                  seriesSpecRepFeaturedModel {
                    ... on ModelFloorPlan {
                      acf_floor_plan {
                        modelExternalImagesRep {
                          modelExternalImagesRepImage {
                            ${respImgQuery}
                          }
                        }
                      }
                    }
                  }
                }
              }              
          }
          ${financeRatesQuery}
          modelFloorPlanBy(uri: $floorplanuri) {
              title
              uri
              link
              acf_floor_plan {
                  modelLayoutId
                  modelLayoutName
                  seriesSpec
                  modelSleepsAdult
                  modelSleepAdultStandard
                  modelSleepsChild
                  modelSleepAdditionalStandard
                  modelSleepsOptional
                  modelSleepChildrenStandard
                  modelStandardFloorPlanBottomDescription
                  modelWeightTare
                  modelWeightTowBall
                  modelBodyLength
                  modelInteriorHeight
                  modelTravelHeight
                  modelTravelLength
                  modelFloorPlanImage {
                    ${respImgQuery}
                  }
                  modelFloorPlanConfigurations {
                    title
                    additionalPrice
                    bottomDescription
                    sleepAdditional
                    sleepAdult
                    sleepChildren
                    mcfgImage {
                      ${respImgQuery}
                    }
                  }
                  modelSeries {
                    ... on Series {
                      uri
                      title
                    }
                  }
                  modelFeatures
              }
          }
          pageBy(uri: "build-price") {
            acf_build_and_price {
              bptHidePrice
            }
          }
      }
    `
    const gqData = await client.query({
      query: GET_DYNAMIC_PROPS,
      variables: {
        seriesuri: params.series,
        floorplanuri: params.floorplan,
      }
    });
    
    //console.log('gqSData>>>>', gqData);

    var modelFooter = {
      text: ''
    }
    var disclaimers = get(gqData, 'data.seriesBy.acf_series.seriesDisclaimer', null);
    if (disclaimers) {
      disclaimers.map(item=>{
        var dText = get(item, 'acf_disclaimer.disclaimerText', null);
        if (dText) {
          modelFooter.text = modelFooter.text + dText;
        }
      });
    }
    
    var item = get(gqData, 'data.seriesBy', null);
    var fpItem = get(gqData, 'data.modelFloorPlanBy', null);
    var models = [];
    var floorplans = [];
    //var fpSize = fpItem.acf_floor_plan.modelLayoutName.match(/(\d+)/)[0] + ' Ft';
    var fpn = fpItem.acf_floor_plan.modelLayoutName;
    var layoutNameArr1L = fpn.split('.').length;
    var layoutNameArr2L = fpn.split('-').length;
    var fpSize = (layoutNameArr1L > 2 && layoutNameArr2L == 3 ? `${fpn.split('.')[0]} Ft - ${fpn.split('.')[1].split('-')[1]}` : fpn);
    var cfgCount = 0;
    var configurations = [{
        id: 'cfg'+cfgCount+fpItem.acf_floor_plan.modelLayoutId,
        size: fpSize,
        shape: 'Standard',
        additionalPrice: 0,
        bottomDescription: get(fpItem, 'acf_floor_plan.modelStandardFloorPlanBottomDescription', null),
        sleepsAdults: get(fpItem, 'acf_floor_plan.modelSleepAdultStandard', null)
                            ? get(fpItem, 'acf_floor_plan.modelSleepAdultStandard', null)
                            : get(fpItem, 'acf_floor_plan.modelSleepsAdult', null),
        sleepsChildren: get(fpItem, 'acf_floor_plan.modelSleepChildrenStandard', null)
                            ? get(fpItem, 'acf_floor_plan.modelSleepChildrenStandard', null)
                            : get(fpItem, 'acf_floor_plan.modelSleepsChild', null),
        sleepsAdditional: get(fpItem, 'acf_floor_plan.modelSleepAdditionalStandard', null)
                            ? get(fpItem, 'acf_floor_plan.modelSleepAdditionalStandard', null)
                            : get(fpItem, 'acf_floor_plan.modelSleepsOptional', null),
        active: '',
        image: get(fpItem, 'acf_floor_plan.modelFloorPlanImage', null) ? refactorRespImg(fpItem.acf_floor_plan.modelFloorPlanImage, [{
            size: 'default',
            key: 'image_size_920x454',
        }]) : null
    }];
    get(fpItem, 'acf_floor_plan.modelFloorPlanConfigurations', null) ? fpItem.acf_floor_plan.modelFloorPlanConfigurations.map(cfgItem => {
        cfgCount++;
        configurations.push({
            id: 'cfg'+cfgCount+fpItem.acf_floor_plan.modelLayoutId,
            size: fpSize,
            shape: get(cfgItem, 'title', null),
            additionalPrice: get(cfgItem, 'additionalPrice', null),
            bottomDescription: get(cfgItem, 'bottomDescription', null),
            sleepsAdults: get(cfgItem, 'sleepAdult', null),
            sleepsChildren: get(cfgItem, 'sleepChildren', null),
            sleepsAdditional: get(cfgItem, 'sleepAdditional', null),
            active: '',
            image: get(cfgItem, 'mcfgImage', null) ? refactorRespImg(cfgItem.mcfgImage, [{
                size: 'default',
                key: 'image_size_920x454',
            }]) :  null
        });
    }) : null;
    var specsFeatures = getFloorplanSpecsFeatures(fpItem.acf_floor_plan.modelLayoutId, [{title:fpItem.acf_floor_plan.seriesSpec}], [fpItem]);
    floorplans.push({
        id: fpItem.acf_floor_plan.modelLayoutId,
        name: fpItem.acf_floor_plan.modelLayoutName,
        href: fpItem.link,
        uri: fpItem.uri,
        floorplan: {
            title: fpItem.acf_floor_plan.modelLayoutName,
            floorplanId: fpItem.acf_floor_plan.modelLayoutId,
            price: '',
            configurations,
            specsFeatures
        }
    });
    var images = [];
    get(gqData, 'data.seriesBy.acf_series.seriesSpecsRep', []).map(sItem => {
      if (sItem.seriesSpecRepTitle == fpItem.acf_floor_plan.seriesSpec) {
        sItem.seriesSpecRepFeaturedModel[0].acf_floor_plan.modelExternalImagesRep.map(model => {
            if (get(model, 'modelExternalImagesRepImage', null)) {
                images.push({
                    image: refactorRespImg(model.modelExternalImagesRepImage, [{
                        size: 'default',
                        key: 'image_size_704x514',
                      },{
                        size: 'md',
                        key: 'image_size_960x514',
                      }])
                });
            }
        });
      }
    });

    models.push({
        id: fpItem.acf_floor_plan.seriesSpec,
        name: fpItem.acf_floor_plan.seriesSpec,
        images,
        href: '',
        active: '',
        floorplans
    });

    const data = {
      modelLogo: {
          bgColour: get(gqData, 'data.seriesBy.acf_series_v2.sv2SubnavColour', null),
          logo: get(gqData, 'data.seriesBy.acf_series_v2.sv2SubnavLogo', null) ?
              refactorRespImg(get(gqData, 'data.seriesBy.acf_series_v2.sv2SubnavLogo', null), [{
              size: 'default',
              key: 'image_size_320x38',
            },{
              size: 'md',
              key: 'image_size_320x38',
            }]): null,
      },
      modelFloorplanConfiguration: {
          seriesName: get(gqData, 'data.seriesBy.title', null),
          seriesUrl: {
              link: {
                  "title": get(gqData, 'data.seriesBy.title', null),
                  "href": `/build-price/${params.series}`,
                  "target": "",
                  "assignedDomains": get(gqData, 'data.seriesBy.acf_domains.assignedDomains', null),
              }
          },
          modelName: fpItem.uri,
          modelFooter,
          modelUrl: `/build-price/${params.series}/floorplan/${params.floorplan}`,
          background: 'grey',
          models
      },
      modelPrice: {
        rates: refactorFinanceRates(gqData, countryCode)
      },
      disablePrice: get(gqData, 'data.pageBy.acf_build_and_price.bptHidePrice', null),
    }
  
    //console.log('dataS1>>>');console.dir(data, { depth: null });
  
    return {
      props: {
        ...data,
        greyBg: true
      }
    }
}


export default BuildPriceStepTwoFloorplanConfigurationPage
  

function getFloorplanSpecsFeatures(id, specs, data) {
  var sortedData = {};
  for (var i=0; i<specs.length; i++) {
    sortedData[specs[i].title] = [];
  }
  var thisSpec = specs[0].title;
  var thisFPSpecs = [];
  var specsTableTitle = ''
  for (var i=0; i<data.length; i++) {
    // sort and reassign features here
    var mF = {};
    //console.log(`data[${i}].acf_floor_plan.modelFeatures`,data[i].acf_floor_plan.modelFeatures.length,data[i].acf_floor_plan.modelFeatures);
    for (var j=0; j<data[i].acf_floor_plan.modelFeatures.length; j++) {
      var section = data[i].acf_floor_plan.modelFeatures[j][0];
      if (typeof mF[section] == 'undefined') {
        mF[section] = {};
      }
      mF[section][data[i].acf_floor_plan.modelFeatures[j][2]] = (section.toLowerCase()=='optional features' ? 'optional' : 'standard');
    }
    data[i].mFData = mF;
    sortedData[data[i].acf_floor_plan.seriesSpec].push(data[i]);
    thisSpec = data[i].acf_floor_plan.seriesSpec;
    thisFPSpecs.push({title: 'Tare Weight (kg)',  value: get(data[i].acf_floor_plan, 'modelWeightTare', null)});
    thisFPSpecs.push({title: 'Towball Weight (kg)',  value: get(data[i].acf_floor_plan, 'modelWeightTowBall', null)});
    thisFPSpecs.push({title: 'Body length (mm)',  value: get(data[i].acf_floor_plan, 'modelBodyLength', null)});
    thisFPSpecs.push({title: 'Interior height (mm)',  value: get(data[i].acf_floor_plan, 'modelInteriorHeight', null)});
    thisFPSpecs.push({title: 'Travel height (mm)',  value: get(data[i].acf_floor_plan, 'modelTravelHeight', null)});
    thisFPSpecs.push({title: 'Travel length (mm)',  value: get(data[i].acf_floor_plan, 'modelTravelLength', null)});
    specsTableTitle = get(data[i].acf_floor_plan, 'modelSeries[0].title', null)
  }
  for (var i=0; i<specs.length; i++) {
    sortedData[specs[i].title] = orderBy(sortedData[specs[i].title], ['acf_floor_plan.modelLayoutName'], ['asc']);
  }
  var currFP = 0;
  for (var i=0; i<sortedData[thisSpec].length; i++) {
    if (sortedData[thisSpec][i].id == id) {
      currFP = i;
      break;
    }
  }
  var models = [];
  var mfTSections = {};
  for (var i=0; i<specs.length; i++) {
    var fpn = get(sortedData[specs[i].title][currFP], 'acf_floor_plan.modelLayoutName', '');
    var modelId = get(sortedData[specs[i].title][currFP], 'acf_floor_plan.modelLayoutId', '');
    var layoutNameArr1L = fpn.split('.').length;
    var layoutNameArr2L = fpn.split('-').length;
    var modelNameFT = (layoutNameArr1L > 2 && layoutNameArr2L == 3 ? `${fpn.split('.')[0]} FT-${fpn.split('.')[1].split('-')[1]}` : fpn);
    models.push({
      series: specs[i].title,
      model: modelNameFT,
      id: modelId
    });
    var mFData = sortedData[specs[i].title][currFP].mFData;
    const keys = Object.keys(mFData);
    keys.forEach((key, index1) => {
      if (typeof mfTSections[key] == 'undefined') {
        mfTSections[key] = {};
      }
      var keys2 = Object.keys(mFData[key]);
      keys2.forEach((key2, index2) => {
        if (typeof mfTSections[key][key2] == 'undefined') {
          mfTSections[key][key2] = {}
        }
        mfTSections[key][key2][`${specs[i].title}:${modelNameFT}`] = mFData[key][key2];
      });
    });
  }
  // console.log('mfTSections3 >>>');
  // console.dir(mfTSections,{depth:null});
  var sections = [];
  const keys = Object.keys(mfTSections);
  keys.forEach((key, index1) => {
    var features = [];
    var keys2 = Object.keys(mfTSections[key]);
    keys2.forEach((key2, index2) => {
      var feature = {
        title: key2,
        values: []
      }
      for (i=0; i<models.length; i++) {
        feature.values.push(get(mfTSections[key][key2], `${models[i].series}:${models[i].model}`, 'na'));
      }
      features.push(feature);
    });
    sections.push(
      {
        title: key,
        features
      }
    )
  });
  return {
    specs: thisFPSpecs, 
    modal: {
      background: "", 
      title: `${specsTableTitle} Specs & Features`,
      models,
      "ctas": [
        {
          "title": "Download Spec Sheet",
          "href": "#",
          "target": "_self",
          "style": "outline"
        }
      ],
      sections
    },
    greyBg: true
  }
}
